import type {QuizSession} from './quizSessionSchema';

export function calculateQuizSessionScoreFromQuestions(questions: {isCorrect?: boolean}[]): number {
  const total = questions.length;
  if (total === 0) {
    return 0;
  }

  const correct = questions.filter((q) => q.isCorrect).length;
  return Math.round((correct / total) * 100);
}

export function calculateQuizSessionScore(session: Pick<QuizSession, 'questions'>): number {
  return calculateQuizSessionScoreFromQuestions(session.questions);
}
